import { useState, type ReactNode } from 'react';

interface RecolherProps {
  rotulo: string;
  abertoInicial?: boolean;
  children: ReactNode;
}

// Toggle leve (ranking, categorias) — mesma animação de altura, tipografia menor.
export default function Recolher({ rotulo, abertoInicial = false, children }: RecolherProps) {
  const [aberto, setAberto] = useState(abertoInicial);

  return (
    <div className="mt-3">
      <button
        type="button"
        onClick={() => setAberto((a) => !a)}
        aria-expanded={aberto}
        className="inline-flex cursor-pointer items-center gap-1.5 text-[13px] font-semibold text-primary-700"
      >
        {rotulo}
        <span
          className={`rel-caret flex h-4 w-4 items-center justify-center transition-transform duration-200 ${
            aberto ? 'rotate-180' : ''
          }`}
        >
          <i className="ri-arrow-down-s-line text-base" />
        </span>
      </button>
      <div
        className={`rel-acordeao grid transition-[grid-template-rows] duration-200 ease-out motion-reduce:transition-none ${
          aberto ? 'grid-rows-[1fr]' : 'grid-rows-[0fr]'
        }`}
      >
        <div className="overflow-hidden">
          <div className="pt-2.5">{children}</div>
        </div>
      </div>
    </div>
  );
}